export default {
  'nav.brand': 'AllChinaBuy Spreadsheet',
  'nav.categories': 'Kategorier',
  'nav.guides': 'Guider',
  'nav.faq': 'FAQ',
  'nav.explore': 'Udforsk Spreadsheet',
  'nav.home': 'Hjem',
  'nav.shoppingGuide': 'Indkøbsguide',
  'nav.sheetCta': 'AllChinaBuy Sheet',

  'hero.badge': 'OPDATERES UGENLIGT · 2026-UDGAVE',
  'hero.title': 'Det mest komplette AllChinaBuy Spreadsheet-katalog',
  'hero.titlePre': 'Det mest komplette',
  'hero.titleHighlight': 'AllChinaBuy Spreadsheet',
  'hero.titleSuffix': 'Katalog',
  'hero.subtitle': 'Opdag tusindvis af kuraterede produktfund inden for sko, tøj, tasker, tilbehør og meget mere. Opdateres ugentligt med kvalitetstjekkede opslag og organiserede kategorier for kloge shoppere.',
  'hero.cta1': 'AllChinaBuy Sheet',
  'hero.cta2': 'Køb nu',
  'hero.trust1': 'Opdateres ugentligt',
  'hero.trust2': 'Kvalitetstjekket',
  'hero.trust3': 'Verificeret',

  'trust.independent': 'Uafhængig ressource',
  'trust.research': 'Research-fokuseret',
  'trust.updated': 'Opdateres løbende',

  'selector.title': 'Gennemse efter kategori',
  'selector.placeholder': 'Vælg en kategori…',
  'selector.all': 'Alle kategorier',

  'categories.title': 'Populære kategorier',
  'categories.badge': 'KURATERET',
  'categories.intro': 'Navigér gennem vores omhyggeligt organiserede samling af AllChinaBuy-spreadsheets. Hver kategori linker direkte til verificerede produktopslag i vores hovedbutik.',
  'categories.subtitle': 'Vælg en kategori for at udforske matchende produkter på hovedwebstedet.',
  'categories.browse': 'Gennemse denne kategori',

  'features.title': 'Hvorfor bruge et spreadsheet til produktresearch?',
  'feature1.title': 'Alt samlet ét sted',
  'feature1.desc': 'Gennemse sko, tøj, tasker og mere fra ét organiseret hub i stedet for at søge på tværs af mange sider.',
  'feature2.title': 'Tydelige kategorier',
  'feature2.desc': 'Gå direkte til den kategori, du interesserer dig for, med en hurtig dropdown eller et-klik-knapper.',
  'feature3.title': 'Uafhængig og ærlig',
  'feature3.desc': 'En uafhængig ressource fokuseret på opdagelse uden falske anmeldelser, priser eller kuponer.',

  'guide.title': 'Hvad er AllChinaBuy Spreadsheet?',
  'guide.p1': 'Et AllChinaBuy-spreadsheet er en organiseret måde at gennemse produktfund på. Det samler populære varer i tydelige kategorier — sko, hættetrøjer, t-shirts, jakker, bukser, tilbehør og mere — så du hurtigt kan opdage produkter og planlægge klogere indkøb.',
  'guide.p2': 'I stedet for at søge side for side kan du bruge kategorierne ovenfor til at gå direkte til den sektion, du har brug for. Hvert link fører dig til den matchende kategori på hovedwebstedet.',
  'guide.p3': 'Dette er en uafhængig ressource bygget omkring produktopdagelse. Vi fokuserer på nyttig, original vejledning — ingen falske anmeldelser, priser eller kuponer — så du altid ved, hvad du ser på.',
  'guide.readMore': 'Læs hele guiden',
  'guide.readMoreSub': 'Lær at bruge spreadsheetet til produktresearch med praktiske tips og en FAQ.',

  'companion.badge': 'Om AllChinaBuy Sheet',
  'companion.title': 'Din ultimative shopping-ledsager',
  'companion.p1': '<strong>AllChinaBuy-spreadsheetet</strong> er blevet et uundværligt værktøj for tusindvis af kloge shoppere verden over. Uanset om du jagter de nyeste sneaker-udgivelser, premium streetwear eller skjulte luksusfund, kan et velorganiseret <strong>produktkatalog</strong> spare dig for timers browsing og hjælpe dig med at opdage produkter, du aldrig selv ville finde.',
  'companion.p2': 'Vores <strong>AllChinaBuy spreadsheet 2026</strong>-katalog samler den mest omfattende samling af verificerede fund — fra Nike- og Jordan-sneakers til Essentials-hoodies, Chrome Hearts-tilbehør og alt derimellem. Hvert spreadsheet opdateres løbende, så du altid har adgang til de friskeste drops og de bedste tilbud.',
  'companion.p3': 'Det, der adskiller vores katalog, er niveauet af kuratering. Vi lister ikke bare hvert spreadsheet, vi støder på. Hver post i vores <strong>AllChinaBuy spreadsheet</strong>-samling gennemgås manuelt for kvalitet, nøjagtighed og relevans. Det betyder, at du bruger mindre tid på at grave gennem døde links og mere tid på at finde præcis det, du vil have.',
  'companion.cta1': 'Besøg hovedbutikken',
  'companion.cta2': 'Læs hele guiden',

  'why.badge': 'HVORFOR VÆLGE OS',
  'why.title': 'Tillid fra tusindvis af shoppere',
  'why.subtitle': 'Vores AllChinaBuy spreadsheet-katalog er bygget på pålidelighed, friskhed og ægte brugerfeedback — her er, hvad der gør det til det foretrukne valg for kloge shoppere i 2026.',
  'why.f1.title': 'Opdateres ugentligt',
  'why.f1.desc': 'Vores katalog opdateres hver uge med de seneste fund, så du aldrig går glip af et nyt drop eller en trendende vare.',
  'why.f2.title': 'Kvalitet verificeret',
  'why.f2.desc': 'Hvert spreadsheet gennemgås manuelt, før det listes. Vi tjekker for døde links, forældede priser og unøjagtige produktbeskrivelser.',
  'why.f3.title': 'Organiserede kategorier',
  'why.f3.desc': 'Gennemse 14 omhyggeligt organiserede kategorier — fra sneakers og hættetrøjer til tilbehør og dufte — for at finde præcis det, du har brug for, på få sekunder.',
  'why.f4.title': 'Hurtig navigation',
  'why.f4.desc': 'Direkte links til verificerede produktopslag i vores hovedbutik fjerner gætteri og får dig fra browsing til køb hurtigere end nogensinde.',
  'why.f5.title': 'Sammenligningsguider',
  'why.f5.desc': 'Side om side-sammenligninger hjælper dig med at vurdere forskellige spreadsheet-muligheder, prisniveauer og agentanbefalinger, før du forpligter dig.',
  'why.f6.title': 'Seneste fund',
  'why.f6.desc': 'Vær på forkant med trends med tidlig adgang til nyopdagede perler, limited releases og diskrete gode tilbud i alle kategorier.',

  'faq.title': 'Ofte stillede spørgsmål',
  'faq.subtitle': 'Alt, hvad du behøver at vide om AllChinaBuy-spreadsheets, hvordan de fungerer, og hvordan du får mest ud af vores katalog.',
  'faq.q1': 'Er dette et officielt AllChinaBuy-websted?',
  'faq.a1': 'Nej, dette er en uafhængig informationsressource og drives ikke af AllChinaBuy.',
  'faq.q2': 'Hvor kan jeg købe produkterne?',
  'faq.a2': 'Alle kategorilinks fører dig til hovedwebstedet, hvor du kan gennemse fulde opslag og foretage køb.',
  'faq.q3': 'Er spreadsheetet gratis at bruge?',
  'faq.a3': 'Ja, det er helt gratis at gennemse kategorier og guider her.',
  'faq.q4': 'Hvordan finder jeg en bestemt vare?',
  'faq.a4': 'Vælg den nærmeste kategori i dropdownen eller knapperne, og gennemse derefter de linkede opslag.',
  'faq.q5': 'Hvor ofte opdateres spreadsheets?',
  'faq.a5': 'Vi stræber efter at holde kategorier og guider aktuelle. Kom tilbage regelmæssigt for de seneste fund og tips.',
  'faq.q6': 'Kan jeg indsende mit eget spreadsheet?',
  'faq.a6': 'I øjeblikket accepterer vi ikke brugerindsendelser. Alle lister er manuelt kurateret af vores redaktionelle team.',

  'cta.title': 'Klar til at udforske AllChinaBuy Spreadsheet?',
  'cta.subtitle': 'Gennemse kategorier og produktfund, eller gå direkte til hovedwebstedet.',
  'cta.button1': 'AllChinaBuy Spreadsheet',
  'cta.button2': 'Køb nu',

  'finalcta.title': 'Klar til at finde dit næste gode tilbud?',
  'finalcta.subtitle': 'Bliv en del af tusindvis af kloge shoppere, der allerede bruger vores AllChinaBuy spreadsheet-katalog. Opdateres ugentligt med de seneste verificerede fund i 14 kategorier.',
  'finalcta.button1': 'Gennemse spreadsheets',
  'finalcta.button2': 'Læs guiden',

  'guides.badge': 'Købsguider',
  'guides.title': 'AllChinaBuy købsguider',
  'guides.subtitle': 'Dybdegående og originale guider til at researche produkter, bestille trygt og sende smartere.',

  'footer.description': 'Et uafhængigt ressourcehub for AllChinaBuy-produktfund, kategorier og købsguider.',
  'footer.tagline': 'Bogmærk vores side og kom tilbage hver uge for de seneste AllChinaBuy spreadsheet-opdateringer, nye kategorier og friske fund i alle 14 kategorier.',
  'footer.readGuide': 'Læs hele guiden',
  'footer.popularCategories': 'Populære kategorier',
  'footer.quickLinks': 'Hurtige links',
  'footer.mainStore': 'Hovedbutik — AllChinaBuy Sheet',
  'footer.buyNow': 'Køb nu',
  'footer.completeGuide': 'Komplet guide 2026',
  'footer.allCategories': 'Alle kategorier',
  'footer.faq': 'FAQ',
  'footer.home': 'Hjem',
  'footer.mainStoreShort': 'Hovedbutik',
  'footer.copyright': 'Alle rettigheder forbeholdes. Ikke tilknyttet AllChinaBuy.',
  'footer.categoriesLink': 'Kategorier',
  'footer.guideLink': 'Købsguide',
  'footer.faqLink': 'FAQ',
  'footer.disclaimer': 'Dette er en uafhængig informationsressource og drives ikke af AllChinaBuy.',
  'footer.rights': 'Alle rettigheder forbeholdes.',
  'footer.externalNote': 'Links til hovedwebstedet åbner i en ny fane.',

  'categories.shoes': 'Sko',
  'categories.hoodies': 'Hættetrøjer / Sweatshirts',
  'categories.tshirts': 'T-Shirts',
  'categories.jackets': 'Jakker',
  'categories.pants': 'Bukser / Shorts',
  'categories.headwear': 'Hovedbeklædning',
  'categories.sets': 'Sæt',
  'categories.underwear': 'Undertøj',
  'categories.jersey': 'Trøjer',
  'categories.accessories': 'Tilbehør',
  'categories.bags': 'Tasker',
  'categories.belts': 'Bælter',
  'categories.perfumes': 'Parfumer',
  'categories.other': 'Andet',
};